import { Router } from "@angular/router";
import { metacomActions } from "@shared/store/metacom/actions";

export const handleConnectionStatus = (router: Router, status?: string) => {
  switch (status) {
    case "200":
      return metacomActions.requestMetacomConnectionSuccess({
        connected: true,
      });

    case "401": {
      router.navigate(["/data-limit"]);
      return metacomActions.requestMetacomConnectionFailed({
        message: "You've exceeded your WiFi data allocation for today.",
      });
    }

    case "403":
      return metacomActions.requestMetacomConnectionFailed({
        message: "We could not connect you to the WiFi, please try again.",
      });

    default:
      //REMOVE THIS
      /*return metacomActions.requestMetacomConnectionSuccess({
        connected: true,
      });*/

      return metacomActions.requestMetacomConnectionFailed({
        message: "Something went wrong, please try again.",
      });
  }
};
